import * as React from "react"
import TextInput from "../../TextInput"
import IVital from "../../../models/staticData/IVital"
import IPatientVital from "../../../models/IPatientVital"
import ModelFactory from "../../../models/ModelFactory"
import {VitalEditMap} from "../../../containers/EditView/VitalsEditViewCont"
import * as _ from "lodash";
import {IPatientVitalResponse} from "../../../models/IPatientVitalResponse";
import AppUtils from "../../../utils/AppUtils";

/**
 * Created by abhinav on 28/01/18.
 */

export interface PatientVitalsEditorProps {
    staticVitalList: IVital[],
    vitalEditMap: VitalEditMap,
    updateVitalEditMap: (vitalEditMap: VitalEditMap) => void,
    patientVitals: IPatientVitalResponse[]
}

export const VitalsEditOrder = ["WEIGHT", "HEIGHT", "SYSTOLIC BP", "DIASTOLIC BP", "PULSE RATE", "RESPIRATORY RATE", "TEMPERATURE", "SPO2", "BMI", "WAIST", "HIP", "WHR"];

class PatientVitalsEditor extends React.Component<PatientVitalsEditorProps> {

    constructor(props: PatientVitalsEditorProps) {
        super(props)
    }

    onVitalChangeHandler = (event: any, vital: IVital) => {
        let isValid = false;
        if (vital.vitalName !== "BP") {
            isValid = !isNaN(event.target.value);
        } else {
            let value = event.target.value.toString();
            if (value !== "") {
                _.map(value.split("/"), (pressure: string) => {
                    if (pressure !== "") {
                        isValid = !isNaN(pressure as any);
                        if (!isValid) return false;
                    }
                })
            } else {
                isValid = true;
            }
        }
        if (isValid) {
            let currVitalValue = event.target.value.trim();
            if ( !_.isEmpty(currVitalValue) ) {
                let newPatientVital: IPatientVital = ModelFactory.createNewPatientVital(currVitalValue, vital.vitalName);
                let newEditedPatientVitals: VitalEditMap = Object.assign({}, this.props.vitalEditMap);
                newEditedPatientVitals[vital.vitalName] = newPatientVital;
                if (newEditedPatientVitals["HEIGHT"] !== undefined && newEditedPatientVitals["WEIGHT"] !== undefined) {
                    let weight: number = parseInt(newEditedPatientVitals["WEIGHT"].vitalValue);
                    let height: number = parseInt(newEditedPatientVitals["HEIGHT"].vitalValue);
                    let bmi: number = weight / ( (height / 100) * ( height / 100 ) );
                    let updatedBMI: IPatientVital = ModelFactory.createNewPatientVital(bmi.toFixed(2).toString(), "BMI");
                    newEditedPatientVitals["BMI"] = updatedBMI;
                }
                if (newEditedPatientVitals["WAIST"] !== undefined && newEditedPatientVitals["HIP"] !== undefined) {
                    let waist: number = parseInt(newEditedPatientVitals["WAIST"].vitalValue);
                    let hip: number = parseInt(newEditedPatientVitals["HIP"].vitalValue);
                    let whr: number = waist / hip;
                    let updatedWHR: IPatientVital = ModelFactory.createNewPatientVital(whr.toFixed(2).toString(), "WHR");
                    newEditedPatientVitals["WHR"] = updatedWHR;
                }
                this.props.updateVitalEditMap(newEditedPatientVitals);
            } else {
                let newEditedPatientVitals: VitalEditMap = Object.assign({}, this.props.vitalEditMap);
                delete newEditedPatientVitals[vital.vitalName];
                if (newEditedPatientVitals["BMI"] !== undefined && (newEditedPatientVitals["HEIGHT"] === undefined || newEditedPatientVitals["WEIGHT"] === undefined)) {
                    delete newEditedPatientVitals["BMI"];
                }
                this.props.updateVitalEditMap(newEditedPatientVitals);
            }
        }
    }

    getEditedVitalValue = (vital: IVital) => {
        let retValue = ""
        if ( this.props.vitalEditMap.hasOwnProperty(vital.vitalName) ) {
            retValue = this.props.vitalEditMap[vital.vitalName].vitalValue;
        }
        return retValue;
    }

    createStaticVitalsListArrayFromObject = (staticList: IVital[]) => {
        let staticVitalListArray: IVital[] = [];
        _.map(VitalsEditOrder, (vital) => {
            _.map(staticList, function(innerVital, index) {
                if (innerVital.vitalName === vital) staticVitalListArray.push(innerVital)
            })
        })
        return staticVitalListArray;
    }

    render() {
        let myInstance = this;
        let vitalsArray = this.createStaticVitalsListArrayFromObject(this.props.staticVitalList);
        return (
            <div className="vital-editor">
                {_.map(vitalsArray, function(vital, index) {
                    let formattedVitalUnit = !_.isNull(vital.unit) ? `(${vital.unit})` : "";
                    let vitalLabelText = vital.vitalName + " " + formattedVitalUnit;
                    let editedVitalValue = myInstance.getEditedVitalValue(vital)
                    let sp, dp
                    if (vital.vitalName === "BP") {
                        sp = !_.isEmpty(editedVitalValue) ? editedVitalValue.split("/")[0] : ""
                        dp = !_.isEmpty(editedVitalValue) ? editedVitalValue.split("/")[1] : ""
                    }
                    let vitalInfo = myInstance.props.patientVitals.filter(currVital => currVital.vitalName.toUpperCase() === vital.vitalName);
                    let currentVital = vitalInfo.length > 0 ? AppUtils.sortPatientVitalHistory(vitalInfo[0].vitalHistoryList)[0].value : "-";
                    let additionalInformation = `Last recorded value: ${currentVital}`;
                    return (
                        <div className="vital-edit-item in-blk mid-align" key={index}>
                            <div className="vital-edit-label">
                                {vitalLabelText}
                            </div>
                            <div className="vital-edit-text">
                                <TextInput value={editedVitalValue} name={vital.vitalName} onChange={(event: any) => {myInstance.onVitalChangeHandler(event, vital)}} additionalInformation={additionalInformation}/>
                            </div>
                        </div>
                    )
                })
                }
            </div>
        )
    }
}

export default PatientVitalsEditor